module.exports = __webpack_public_path__ + "img/msu3-5.85a4f1b1.png";